<template>
<v-container>
  <v-card style="border-radius: 8px;">
    <v-container>
    <v-card-title>
      <v-btn flat round color="primary" @click="createAssest($event)">+ Add new Asset</v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="cassests"
      :search="search"
    >
      <template v-slot:items="props">
        <td>{{ props.item.nickname }}</td>
        <td>{{ props.item.type }}</td>
        <td>{{ props.item.id }} </td>
        <td class="justify-center">
          <v-icon
            small
            @click="deleteItem(props.item)"
          >
            delete
          </v-icon>
        </td>
      </template>
      <v-alert v-slot:no-results :value="true" color="error" icon="warning">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>
    </v-container>
  </v-card>
  <v-menu v-model="openmenu"
        :close-on-click = "false"
        :position-x="x"
        :position-y="y"
        offset-x
        :close-on-content-click="false"
        :nudge-width="600">
    <v-card>
    <v-card-title>
      <div>
        <h3 class="subheading">Create New Asset</h3>
        <div class="caption grey--text">Browse Image / Video(mp4) / Audio / File</div>
      </div>
    </v-card-title>
    <v-divider></v-divider>
    <v-container grid-list-xl>
      <v-layout>
      <v-flex xs6>
        <v-select
          :items="mediatypes"
          label="Media type"
          v-model="mediatype"
        ></v-select>
      </v-flex>
      <v-flex xs6>
      <v-text-field
        v-model="nickname"
        label="Nick name"
        counter=50
      ></v-text-field>
      </v-flex>
      </v-layout>
      <v-layout>
          <v-flex xs11>
            <v-text-field
              v-model="mediafile"
              placeholder="Search file"
              readonly
            ></v-text-field>
            </v-flex>
            <v-flex xs1>
            <label for="fileinput"> 
              <v-icon class="mt-4" style="cursor: pointer">search</v-icon>
            </label>
            <input id="fileinput" type="file" style="display:none" @change="selectfile()">
          </v-flex>
      </v-layout>
      <v-card-actions class="ma-0">
          <v-spacer></v-spacer>                  
              <v-btn round flat color="primary" @click="cancelCard">Cancel</v-btn>
              <v-btn round flat color="primary" @click="saveCard">Save</v-btn>                
      </v-card-actions> 
    </v-container>
    </v-card>
</v-menu> 
  </v-container>
</template>

<script>
import {str,firebase} from '@/plugins/firebase.js';
import store from '../store';
  export default {
    data () {
      return {
        nickname:null,
        mediafile:null,
        uploadfile:null,
        mediatype:null,
        mediatypes:['image','video','audio','file'],
        x:null,
        y:null,
        search: '',
        headers: [
          { text: 'Nick name', align: 'left', value: 'nickname'},
          { text: 'Type', align: 'left', value: 'type'},
          { text: 'Assest id', value: 'id', sortable: false, },
          { text: '', value: 'name', sortable: false}
        ]
      }
    },
    methods:{
      createAssest(event){
            event.preventDefault()
            this.x = event.clientX
            this.y = event.clientY
            let status = true
            this.$store.dispatch('aresponsemenuStatusChange',status)
        },
        saveCard(){
            // let index = this.$store.state.currentResponseIndex
            // let textmessage = {"text":this.text}
            // let message = {"message":textmessage,"type":"text"}      
            // this.$store.dispatch('acreateresponseMessage', {index,message})
            // this.text = null
            let assestname = this.nickname
            let type = this.mediatype
            let pageid = this.$store.state.selectedPage
            let accessToken = this.$store.state.pageDetails.accessToken
            var storageRef = str.ref();
            let file = this.uploadfile
            var uploadTask = storageRef.child(file.name).put(file)
            uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
            function(snapshot) {
              // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
              var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              console.log('Upload is ' + progress + '% done');
              switch (snapshot.state) {
                case firebase.storage.TaskState.PAUSED: // or 'paused'
                  console.log('Upload is paused');
                  break;
                case firebase.storage.TaskState.RUNNING: // or 'running'
                  console.log('Upload is running');
                  break;
              }
            }, function(error) {

            // A full list of error codes is available at
            // https://firebase.google.com/docs/storage/web/handle-errors
            switch (error.code) {
              case 'storage/unauthorized':
                // User doesn't have permission to access the object
                break;

              case 'storage/canceled':
                // User canceled the upload
                break;

              case 'storage/unknown':
                // Unknown error occurred, inspect error.serverResponse
                break;
            }
          }, function() {
            // Upload completed successfully, now we can get the download URL
            uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
              FB.api(
                    "/"+pageid+"/message_attachments?access_token=" +accessToken,
                    'POST',
                    {    
                      "message":{
                        "attachment":{
                          "type":type, 
                          "payload":{
                            "is_reusable": true,
                            "url":downloadURL
                          }
                        }
                      }
                    },
                    function (response) {
                      console.log(response)
                      let asset = {"nickname": assestname,"type":type,"id":response.attachment_id}
                      console.log(asset)
                        store.dispatch('acreateasset',{asset})
                        // Create a reference to the file to delete
                        var desertRef = storageRef.child(file.name);
                        // Delete the file
                        desertRef.delete().then(function() {
                          console.log( "File deleted successfully")
                        }).catch(function(error) {
                          // Uh-oh, an error occurred!
                        });
                });
              
            });
          });
            let status = false
            this.mediafile = null
            this.$store.dispatch('aresponsemenuStatusChange',status)
        },
        cancelCard(){
          let status = false
          this.$store.dispatch('aresponsemenuStatusChange',status)
          this.mediafile = null
          this.nickname = null
        },
        selectfile(){
          console.log(event.target.files[0])
          this.uploadfile = event.target.files[0]
          this.mediafile = event.target.files[0].name
        }
    },
    computed:{
      openmenu(){
            return this.$store.state.responseMenuStatus
        },
        cassests(){
          if(this.$store.state.assets != null){
          return this.$store.state.assets
          }
          else{
            return []
          }
        }
    }
  }
</script>